import React, { useCallback, useRef, useState } from "react";
import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";
import "./VideoBackground.css";
import videoWebm from "../../assets/calculadora.webm";
import videoMp4 from "../../assets/calculadora.mp4";

const VideoBackground = () => {
  const [isPlaying, setIsPlaying] = useState(true);
  const videoRef = useRef(null);

  const particlesInit = useCallback(async (engine) => {
    await loadFull(engine);
  }, []);

  const togglePlay = () => {
    if (!videoRef.current) return;
    isPlaying ? videoRef.current.pause() : videoRef.current.play();
    setIsPlaying(prev => !prev);
  };

  return (
    <div className="video-wrapper">

      {/* Vídeo de fundo — webm primeiro (menor), mp4 como fallback */}
      <video
        ref={videoRef}
        autoPlay
        muted
        loop
        playsInline
        className="video-bg"
        onEnded={() => {
          if (videoRef.current) {
            videoRef.current.currentTime = 0;
            videoRef.current.play();
          }
        }}
      >
        <source src={videoWebm} type="video/webm" />
        <source src={videoMp4} type="video/mp4" />
      </video>

      {/* Gradient overlay com cor da marca */}
      <div className="video-overlay" />

      {/* Vinheta nas bordas */}
      <div className="video-vignette" />

      {/* Partículas sutis */}
      <Particles
        id="tsparticles"
        className="video-particles"
        init={particlesInit}
        options={{
          particles: {
            number: { value: 28, density: { enable: true, value_area: 900 } },
            color: { value: "#ffffff" },
            opacity: {
              value: 0.12,
              random: true,
              anim: { enable: true, speed: 0.3, opacity_min: 0.04, sync: false },
            },
            size: { value: 2.5, random: true },
            move: {
              enable: true,
              speed: 0.45,
              direction: "none",
              random: true,
              straight: false,
              out_mode: "out",
            },
            line_linked: {
              enable: true,
              distance: 160,
              color: "#ffffff",
              opacity: 0.06,
              width: 1,
            },
          },
          interactivity: {
            detect_on: "canvas",
            events: { onhover: { enable: false }, onclick: { enable: false } },
          },
          retina_detect: true,
        }}
      />

      {/* Controle de pause/play */}
      <button
        onClick={togglePlay}
        className="video-control-btn"
        title={isPlaying ? "Pausar" : "Reproduzir"}
      >
        {isPlaying ? (
          <svg width="10" height="12" viewBox="0 0 10 12" fill="white">
            <rect x="0" y="0" width="3.5" height="12" rx="1" />
            <rect x="6.5" y="0" width="3.5" height="12" rx="1" />
          </svg>
        ) : (
          <svg width="10" height="12" viewBox="0 0 10 12" fill="white">
            <polygon points="0,0 10,6 0,12" />
          </svg>
        )}
      </button>

    </div>
  );
};

export default VideoBackground;
